import { createSelector } from '@reduxjs/toolkit';
import { selfMsgSelector } from './self';

const selectedLangSelector = createSelector(selfMsgSelector, (messages) => messages.selectedLang);

export default selectedLangSelector;
